<template>
    <div class="page-login">
        <div class="left-part">
            <div class="inner">
                <IconSvg class="logo" :name="'logo-white'" />
            </div>
        </div>
        <div class="right-part">
            <div class="inner">
                <div class="head">
                    <h1 class="title title--h1">
                        {{ $t('auth.loginPage.title') }}
                    </h1>
                    <p class="message">
                        {{ $t('auth.loginPage.headMessage') }}
                    </p>
                </div>

                <FormKit
                    id="loginForm"
                    :actions="false"
                    class="form"
                    type="form"
                    v-model="formData"
                    @submit-invalid="invalidSubmit"
                    @submit="onSubmit">

                    <FormKit
                        type="email"
                        name="email"
                        :label="$t('auth.loginPage.form.email.label')"
                        :placeholder="$t('auth.loginPage.form.email.placeholder')"
                        validation="required|email"
                    />
                    <FormKit
                        type="password"
                        name="password"
                        suffix-icon="eyeClosed"
                        :label="$t('auth.loginPage.form.password.label')"
                        :placeholder="$t('auth.loginPage.form.password.placeholder')"
                        validation="required"
                        @suffix-icon-click="handleIconClick"
                    />

                    <TurnstileWidget
                        class="turnstile-wrapper"
                        @verified="onCaptchaVerified"
                        @expired="onCaptchaExpired"
                        @error="onCaptchaError"
                    />

                    <Button
                        @click="submitForm('loginForm')"
                        icon="lock"
                        size="big"
                        :loading="isLoading"
                        :disabled="!captchaToken || isLoading">
                        {{ $t('auth.loginPage.form.submit') }}
                    </Button>

                </FormKit>

            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import IconSvg from '@/components/atoms/ASvg.vue'
    import Button from '@/components/atoms/Button.vue'
    import TurnstileWidget from '@/components/atoms/TurnstileWidget.vue'
    import { submitForm } from '@formkit/core'
    import { useI18n } from 'vue-i18n';
    import { toast } from 'vue3-toastify';
    import { ref } from 'vue';
    import { useUserStore } from '@/stores/UserStore'
    import { useRouter } from 'vue-router'

    const { t } = useI18n();
    const router = useRouter()
    const userStore = useUserStore()
    const isLoading = ref(false)
    const formData = ref(null)
    const captchaToken = ref('')

    const handleIconClick = (node, e) => {
        node.props.suffixIcon = node.props.suffixIcon === 'eye' ? 'eyeClosed' : 'eye'
        node.props.type = node.props.type === 'password' ? 'text' : 'password'
    }

    function onCaptchaVerified(token: string) {
        captchaToken.value = token
    }

    function onCaptchaExpired() {
        captchaToken.value = ''
    }

    function onCaptchaError() {
        captchaToken.value = ''
    }

    function invalidSubmit() {
        toast.error('Le formulaire contient des erreurs')
    }

    async function onSubmit(values: any) {
        if (!captchaToken.value) {
            toast.error('La vérification de sécurité est requise')
            return
        }
        isLoading.value = true
        const result = await userStore.getAccessToken(values.email, values.password, captchaToken.value)
        if (result) {
            toast(t('toast.welcome', {'name': userStore.me?.firstName}))
            router.push({name: 'organisations'});
        }
        else {
            captchaToken.value = ''
            isLoading.value = false
        }
    }

</script>

<style scoped>
    .turnstile-wrapper {
        display: block;
        margin-bottom: 20px;
    }
    :deep(.turnstile-root) {
        display: block;
        margin-bottom: 20px;
    }
</style>
